export default __webpack_public_path__ + "static/media/review_list.28fa17b2.svg";